<ion-grid fixed>
  <ion-row class="pad6">
    <ion-col size="6">
      <ion-button
        (click)="onClick()"
        expand="block"
        class="border-r10 ion-no-padding white-btn"
        (click)="onClick()"
      >
        <div class="btn_container ion-padding-horizontal">
          <custom-icon
            [iconName]="wpChatSupport ? 'CHAT_ICON_WP' : 'CHAT_ICON'"
            [width]="20"
            [height]="20"
          ></custom-icon>
          <div class="contact-info fs-3 font500" *ngIf="themeService.getChatSupport">
            {{ "support_widget.chat" | translate }}
          </div>
        </div>
      </ion-button>
    </ion-col>
    <ion-col size="6">
      <ion-button
      (click)="handleEmailSupport()"
        expand="block"
        class="border-r10 ion-no-padding white-btn"
        (click)="handleEmailSupport()"
      >
        <div class="btn_container ion-padding-horizontal">
          <custom-icon
            iconName="MAIL_ICON"
            [width]="22"
            [height]="22"
          ></custom-icon>
          <div class="contact-info fs-3 font500" *ngIf="themeService.getEmailSupport">
            {{ "support_widget.email" | translate }}
          </div>
        </div>
      </ion-button>
    </ion-col>
  </ion-row>
</ion-grid>
